import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TriangleAlert } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

export default function NotFound() {
  const { fr } = useLanguage();

  return (
    <div className="min-h-screen pt-[76px] flex items-center justify-center" style={{ backgroundColor: '#000' }}>
      <SEO
        title="Wrong Trail"
        description="You've gone off-road. This page doesn't exist — head back to camp at Total Composites."
        path="/404"
      />
      <div className="text-center px-6 max-w-xl">

        {/* Danger sign */}
        <div className="relative inline-block mb-6">
          <div className="w-0 h-0 mx-auto" style={{ borderLeft: '52px solid transparent', borderRight: '52px solid transparent', borderBottom: '90px solid #E8520A' }} />
          <div className="absolute inset-0 flex items-center justify-center" style={{ paddingTop: 22 }}>
            <span className="text-black font-black text-2xl" style={{ fontFamily: 'Inter, sans-serif' }}>!</span>
          </div>
        </div>

        <h1 className="text-6xl sm:text-8xl font-black text-white mb-2 uppercase" style={{ fontFamily: 'Inter, sans-serif', lineHeight: 1, letterSpacing: '-0.03em' }}>
          {fr ? 'FAUSSE ROUTE' : 'WRONG TRAIL'}
        </h1>

        <p className="text-xs font-bold uppercase tracking-widest mb-6" style={{ color: '#E8520A', letterSpacing: '0.2em' }}>
          {fr ? 'Erreur 404 — Hors piste' : 'Error 404 — Off the map'}
        </p>

        <p className="text-gray-400 text-sm sm:text-base mb-4 leading-relaxed max-w-md mx-auto">
          {fr
            ? "On dirait que vous avez pris un mauvais sentier. Pas de panique — même les meilleurs explorateurs se perdent parfois."
            : "Looks like you took a wrong turn. Don't worry — even the best explorers get lost sometimes."}
        </p>
        <p className="text-gray-500 text-xs mb-10">
          {fr ? "Faisons demi-tour vers le camp de base." : "Let's turn around and head back to base camp."}
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-white border border-white px-10 py-4 hover:bg-white hover:text-black transition-all duration-300"
        >
          <ArrowLeft size={15} />
          {fr ? "Retour au camp" : 'Back to camp'}
        </Link>
      </div>
    </div>
  );
}
